import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types'; // or PropTypes = require('prop-types');
import AuthService from '../../services/AuthService';
import StorageService from '../../services/Storage';
import ComponetWithHeader from '../CompentWithHeader/ComponetWithHeader';
import ComponentWithoutHeader from '../ComponentWithoutHeader/ComponentWithoutHeader';
import ComponentWithoutSideNav from '../ComponentWithoutSideNav/ComponentWithoutSideNav';
import { Roles } from '../../constants/constant.role';


/**
 * private route component to prevent unauthorize access
 */
const PrivateRoute = ({ component: Component, sidenav, header,
  // role,
  footer = false, isPrivateAndPublic, routePermission, ...rest }) => {

  // uncomment  when authentication api implement
  const isAuthenticated = AuthService.isAuthenticated();
  return (
    <Route
      {...rest}
      render={props => {

        if (isAuthenticated === true || isPrivateAndPublic) {

          let userDetail = StorageService.getUserDetail();
          let userRole = userDetail && userDetail.type ? userDetail.type : null;

          let permissions = [];

          if (userDetail && userDetail.permissions) {
            permissions = userDetail.permissions;
          }

          if (!isPrivateAndPublic) {
            if (!userRole) {
              AuthService.logout();
              return <Redirect to={{
                pathname: '/login',
              }}
              />
            }

            let redirectToPage = false;

            for (let i = 0; i < permissions.length; i++) {
              // let currentPermission = permissions[i];
              // if (permissions.includes(currentPermission)) {
              if (permissions.includes(routePermission[0])) {
                redirectToPage = true;
                break;
              }
            }

            if (!redirectToPage) {
              if ((userRole === Roles.FLEET_MANAGER_ROLE || userRole === Roles.ZONAL_FLEET_MANAGER_ROLE)) {
                return <Redirect to={{
                  pathname: '/'
                }}
                />
              } else {
                if (userDetail && userDetail.is_login_first_time === true) {
                  return <Redirect to={{
                    pathname: '/on-boarding',
                  }}
                  />
                } else {
                  return <Redirect to={{
                    pathname: '/',
                  }}
                  />
                }
              }
            } else {
              // console.log("not valid route");
            }
          }

          // let userDetail = StorageService.getUserDetail();
          if (userDetail && userRole === Roles.FLEET_ROLE && userDetail.is_login_first_time === true) {
            return <Redirect to={{
              pathname: '/on-boarding',
            }}
            />
          }
          if (isPrivateAndPublic && !isAuthenticated) {
            header = !isPrivateAndPublic;
            sidenav = !isPrivateAndPublic;
          }
          if (header === true && sidenav === true && userDetail && !userDetail.temp_fleet) {
            return <ComponetWithHeader component={Component} {...props} footer={footer} />
          } else if (header === true && sidenav === false) {
            return <ComponentWithoutSideNav component={Component} {...props} />
          } else {
            return <ComponentWithoutHeader component={Component} {...props} />
          }
        } else {
          return <Redirect to={{
            pathname: '/login',
          }}
          />
        }
      }
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
};

export default PrivateRoute;
